<script lang="ts">
    import { MenuBar as MenuBarComp } from "../../../../svelte-editor-layout";
    import { COMMANDS, MENU } from "$lib/commands";
    import { file } from "$lib/state";
</script>

<!----------------------------------------------------------------------------->

<div class="menubar">
    <MenuBarComp items={MENU} />
    <span on:click={() => COMMANDS.commands["file.rename"].invoke()}>
        {#if $file}
            {$file.name}
        {/if}
    </span>
</div>

<!----------------------------------------------------------------------------->

<style>
    .menubar {
        display: grid;
        grid-template-columns: 1fr minmax(0, max-content) minmax(0, 1fr);
    }
</style>
